var _rect, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWarning(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_737_5491",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 23.9984,
    height: 24,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_737_5491)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.73439 21C1.96407 21 1.48301 20.1657 1.86895 19.499L11.1338 3.49495C11.519 2.82963 12.4796 2.82963 12.8647 3.49495L22.1296 19.499C22.5156 20.1657 22.0345 21 21.2642 21H2.73439ZM4.44978 19H19.5488L11.9993 6L4.44978 19ZM11.9993 18C12.2826 18 12.5203 17.904 12.7122 17.712C12.9036 17.5207 12.9992 17.2833 12.9992 17C12.9992 16.7167 12.9036 16.4793 12.7122 16.288C12.5203 16.096 12.2826 16 11.9993 16C11.716 16 11.4787 16.096 11.2873 16.288C11.0953 16.4793 10.9994 16.7167 10.9994 17C10.9994 17.2833 11.0953 17.5207 11.2873 17.712C11.4787 17.904 11.716 18 11.9993 18ZM10.9994 14.0001C10.9994 14.5523 11.447 15 11.9993 15C12.5515 15 12.9992 14.5523 12.9992 14.0001V10.9999C12.9992 10.4477 12.5515 10 11.9993 10C11.447 10 10.9994 10.4477 10.9994 10.9999V14.0001Z",
    fill: "#CCB152"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarning);
export default __webpack_public_path__ + "static/media/warning.9585b65c9c1040ecb515db4b16e11e9d.svg";
export { ForwardRef as ReactComponent };